import { createRouter, createWebHistory } from "vue-router";


import Index from "./components/Index/IndexPage.vue";
import AboutUs from "./components/AboutUs/AboutUs.vue";
import ContactUs from "./components/ContactUs/ContactUs.vue";
import UserProfile from "./components/UserProfile/UserProfile.vue";
import RegisterUser from "./components/Booking/GetStarted/RegisterUser.vue";
import SeatLayout from "./components/Booking/SeatSelection/SeatSelection.vue";
import MovieDetails from "./components/Booking/MovieDetails/MovieDetails.vue";
import Razorpay from "./components/Booking/Razorpay/RazorPay.vue";
import Moviefood from "./components/Booking/MovieFood/MovieFood.vue";
import BookingSuccess from "./components/Booking/BookingSuccess/BookingSuccess.vue";
import SiteError from "./components/UI/SiteError.vue";
import DigiFlex from "./components/Footer/DigiFlex.vue";
import FooterDevices from "./components/Footer/FooterDevices.vue";
import FooterFaq from "./components/Footer/FooterFaq.vue";
import FooterSupport from "./components/Footer/FooterSupport.vue";
import HelpCentre from "./components/Footer/HelpCentre.vue";
import LegalNotices from "./components/Footer/LegalNotices.vue";
import PrivacyPolicy from "./components/Footer/PrivacyPolicy.vue";
import RefundPolicy from "./components/Footer/RefundPolicy.vue";



const router = createRouter({
    history: createWebHistory(),
    routes: [
      /*{name:"index",path:'/',redirect:'/index'},*/
      {
            path: '/',
            name:'home',
            components:{default:Index},

        },
      {name:"index",
        path: "/index",
        components: {default:Index},
      },
      
      {
        name:"AboutUs",
          path:"/about",
          component:AboutUs,
      },
      {
        name:"DigiFlex",
          path:"/digiflex",
          component:DigiFlex,
      },
      {
        name:"FooterDevices",
          path:"/devices",
          component:FooterDevices,
      },      {
        name:"FooterFaq",
          path:"/faq",
          component:FooterFaq,
      },      {
        name:"FooterSupport",
          path:"/support",
          component:FooterSupport,
      },      {
        name:"HelpCentre",
          path:"/helpcentre",
          component:HelpCentre,
      },      {
        name:"LegalNotices",
          path:"/termsofservice",
          component:LegalNotices,
      },      {
        name:"PrivacyPolicy",
          path:"/privacypolicy",
          component:PrivacyPolicy,
      },      {
        name:"RefundPolicy",
          path:"/refundpolicy",
          component:RefundPolicy,
      },
      {
        name:"ContactUs",
          path:"/contactus",
          component:ContactUs,
          // components:{default:ContactUs},
      },

      {
        name:"UserProfile",
          path:"/user",
          components:{default:UserProfile},
      },

      {
        name:"RegisterUser",
          path:"/registeruser",
          components:{default:RegisterUser},
      },

      {
        name:"SeatLayout",
          path:"/seatlayout/:showid",
          components:{default:SeatLayout},

      },


      {
        name:"MovieDetails",
          path: "/moviedetails/:slug",
          components:{default:MovieDetails},
      },

      {
        name:"Razorpay",
          path:"/razorpay",
          components:{default:Razorpay},
      },

      {
        name:"Moviefood",
          path:"/moviefood/",
          components:{default:Moviefood},
      },    

      {
        name:"BookingSuccess",
          path:"/bookingsuccess/:showid",
          components:{default:BookingSuccess},
      },
      {
        name:"SiteError",
          path:"/notfound",
          components:{default:SiteError},
      },
      {
        name:"ticket-failed",
          path:"/ticket-failed",
          components:{default:SiteError},
      },
      
     
      {
        path:'/:notFound(.*)',
        redirect:'/notfound'

      }
    ],
    
    linkActiveClass:'active',
    scrollBehavior(to) {
      // always scroll to top
      if (to.hash) {
        return {
          el: to.hash,
          behavior: 'smooth',
        }
      }
      else{
        return { top: 0 }
      }
    },
  });
 export default router;